import {
  RiArrowDownSLine,
  RiArrowUpDownLine,
  RiCloseLine,
  RiSearchLine,
} from "react-icons/ri";
import css from "./memory.module.scss";

export const MEMORY_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "updated", label: "Recently updated" },
];

// The server does the matching and sorting. This row only holds the values.
export default function MemorySearch({ search, sort, onSearch, onSort }) {
  return (
    <div className={css.search}>
      <label className={css.searchField}>
        <RiSearchLine className={css.searchIcon} aria-hidden="true" />
        <input
          type="search"
          className={css.searchInput}
          aria-label="Search memories"
          placeholder="Search memories"
          value={search}
          maxLength={100}
          onChange={(event) => onSearch(event.currentTarget.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape" && search) {
              event.stopPropagation();
              onSearch("");
            }
          }}
        />
        {search && (
          <button
            type="button"
            className={css.searchClear}
            aria-label="Clear search"
            onClick={() => onSearch("")}
          >
            <RiCloseLine aria-hidden="true" />
          </button>
        )}
      </label>
      <label className={css.sortField}>
        <RiArrowUpDownLine className={css.sortIcon} aria-hidden="true" />
        <select
          className={css.sortSelect}
          aria-label="Sort memories"
          value={sort}
          onChange={(event) => onSort(event.currentTarget.value)}
        >
          {MEMORY_SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <RiArrowDownSLine className={css.sortChevron} aria-hidden="true" />
      </label>
    </div>
  );
}
